<template>
  <div>
    <no-data v-if="reports.length === 0" />
    <c-report-item
      v-for="(item) in reports.flat()"
      v-else
      :key="item.key"
      :data="item"
    />
  </div>
</template>

<script>
import CReportItem from '../ui/CReportItem.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import apiService from '../../apiService'
import { mapGetters, mapState } from 'vuex'
import { Notification } from 'uiv'

export default {
  name: 'Report',
  components: { CReportItem, NoData },
  data () {
    return {
      fetchingReports: false,
      isWatchEnabled: false, // Разрешить отслеживание изменений в watches
      reports: []
    }
  },
  computed: {
    ...mapGetters({
      getPeriod: 'Period/getPeriod'
    }),
    ...mapState({
      domainSelected: state => state.serm.client.domains.selected
    }),
    // Свойства для отслеживания
    watches () {
      return {
        domain: this.domainSelected,
        period: this.period
      }
    }
  },
  watch: {
    // Загрузка отчётов при обновлении страницы
    getDomain: function (val) {
      if (val) {
        this.domain = val
      }
    },
    getPeriod: function (val) {
      if (val) {
        this.period = val
      }
    },
    watches: {
      handler (val) {
        const allowFetchData = Object.values(val).every(x => x !== undefined && x !== null)
        // Если все свойства проинициализированы и активировано отслеживание состояний, делаем нужные запросы
        if (allowFetchData && this.isWatchEnabled) {
          this.fetchReports().then(this.onReportsResolve)
        }
      },
      deep: false,
      immediate: true,
      once: true // Фикс с дублирующимися запросами при генерации события mount
    }
  },
  mounted () {
    this.fetchReports().then(this.onReportsResolve)
    // Включаем отслеживание состояний
    const self = this
    self.$nextTick(() => {
      self.enableWatch()
    })
  },
  methods: {
    /**
     * Включает отслеживание состояний
     */
    enableWatch () {
      if (!this.isWatchEnabled) {
        this.isWatchEnabled = true
      }
    },
    /**
     * Метод-обёртка над запросом к API /api/serm/reports
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchReports () {
      this.fetchingReports = true
      return new Promise(resolve => {
        if (this.domainSelected) {
          apiService.getReports(
            this.domainSelected.url,
            this.getPeriod.from.toLocaleDateString('en-CA'), // YYYY-mm-dd
            this.getPeriod.to.toLocaleDateString('en-CA'), // YYYY-mm-dd
            'report'
          )
            .then(response => {
              this.fetchingReports = false
              resolve(response.data)
            })
            .catch(() => {
              this.fetchingReports = false
              Notification.notify.error({
                title: 'Ошибка',
                content: 'Не удалось загрузить отчёты.'
              })
            })
        }
      })
    },
    /**
     * Выводит данные в компонент
     * @param data Данные из Promise
     */
    onReportsResolve (data) {
      this.reports = data.reports
    }
  }
}
</script>
